import React, { useState } from "react";

/**
 * A health warning shown as one line, with its explanation on demand.
 *
 * These used to render as full cards: a position raising three of them pushed
 * every figure below the fold, because the alerts sit between the tab bar and the
 * tab content. The title carries the diagnosis, so it stays visible; the reasoning
 * and the remedy buttons open on click.
 *
 * Same arguments as the previous MoondanceLayout.alertBlock(title, body, type),
 * so call sites did not have to change.
 */
export default function CollapsibleAlert({ title, body, type = "warning" }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="card border mb-2">
            <button
                type="button"
                className={`card-header bg-soft-${type} d-flex align-items-center w-100 border-0 text-start`}
                style={{ gap: '0.6em', cursor: 'pointer' }}
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >
                <i className="mdi mdi-alert-outline" />
                <span className="font-size-14 fw-medium flex-grow-1 my-1">{title}</span>
                <i className={open ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
            </button>
            {open ? <div className="card-body pt-2">{body}</div> : null}
        </div>
    );
}
